/**
 * Global discount code (former voucher) types
 */

export enum DiscountCodeDiscountType {
  SUM = 'sum',
  PERCENTAGE = 'percentage',
}

export enum DiscountCodeStatusType {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export type DiscountCodeType = {
  code: string;
  created_at: Date;
  discount_amount: string;
  discountAmount: string;
  discount_type: DiscountCodeDiscountType;
  discountType: DiscountCodeDiscountType;
  id: number;
  shop_id: number;
  status: DiscountCodeStatusType;
  updated_at: Date;
};

export type PartialDiscountCodeType = {
  code?: string;
  created_at?: Date;
  discount_amount?: string;
  discountAmount?: string;
  discount_type?: DiscountCodeDiscountType;
  discountType?: DiscountCodeDiscountType;
  id?: number;
  shop_id?: number;
  status?: DiscountCodeStatusType;
  updated_at?: Date;
};

export type DiscountCodeConfirmationType = {
  code: string;
  discountAmount: string;
  discountedPrice: string;
  discountedTotalsWithShippingPrices: {
    [deliveryProvider: string]: string;
  };
};

export interface IAppliedDiscountCode {
  code: string;
  name: string;
  discountAmount: string;
  discountType: string;
}
